export enum FeatureToggle {
  connectedStores = 'rt_connected_stores',
  notOnFile = 'rt_connected_stores_caper_not_on_file',
  inventoryIntelligence = 'rt_connected_stores_inventory_intelligence',
  staffBarcodeManagement = 'rt_caper_staff_barcode_management',
}
